import React from 'react';
import PropTypes from 'prop-types';
import { BodyText, HeadingText, Link, Icon } from '@paypalcorp/pp-react';
import {
  parseData,
  preventTabNabbing,
  detailsFeesComponentClick
} from '../../../lib/helpers';

export const feesCard = (feeCardContent = [], handleClickFPTI, app = {}) => {
  return (
    <>
      {feeCardContent.map((fee, idx) => (
        <IncludedCardFee
          app={app}
          key={`details-fee-${idx}`}
          componentContent={fee}
          handleClickFPTI={handleClickFPTI}
        />
      ))}
    </>
  );
};

export const feesSideSection = ({ feesSideContent = {} }) => {
  const {
    subtitleLink = '[]',
    subtitle,
    title,
    handleClickFPTI,
    app = {}
  } = feesSideContent;
  const { context: { location: { domain } = {} } = {} } = app;
  const parsedSubtitleLink = parseData(subtitleLink)[0] || {};

  return (
    <div className="details-fees-side">
      <HeadingText level={2} >{title}</HeadingText>
      <BodyText  className="font-size-p">{subtitle}</BodyText>
      {parsedSubtitleLink?.url && (
        <Link
          rel={preventTabNabbing(parsedSubtitleLink.url, domain)}
          href={parsedSubtitleLink.url}
          onClick={() =>
            detailsFeesComponentClick(
              parsedSubtitleLink.fptiLinkName,
              handleClickFPTI
            )
          }
        >
          {parsedSubtitleLink.text}
        </Link>
      )}
    </div>
  );
};

export const feesFooterSection = (feesSideContent = {}) => {
  const {
    subtitleLink = '[]',
    handleClickFPTI,
    legalDisclaimer = '',
    app = {}
  } = feesSideContent;
  const { context: { location: { domain } = {} } = {} } = app;
  const parsedSubtitleLink = parseData(subtitleLink)[0];

  if (!legalDisclaimer && !parsedSubtitleLink?.url) {
    return null;
  }

  return (
    <div className="details-fees-footer">
      {legalDisclaimer && (
        <div dangerouslySetInnerHTML={{ __html: legalDisclaimer }} />
      )}
      {parsedSubtitleLink?.url && (
        <div className="details-fees-footer-link">
          <Link
            className="undo-link-styles"
            rel={preventTabNabbing(parsedSubtitleLink.url, domain)}
            href={parsedSubtitleLink.url}
            onClick={() =>
              detailsFeesComponentClick(
                parsedSubtitleLink.fptiLinkName,
                handleClickFPTI
              )
            }
          >
            <div className="details-fees-footer-link-inner">
              <span className="details-fees-footer-link-inner-text">
                {parsedSubtitleLink.text}
              </span>
              <Icon size="sm" name={'chevron-right'} />
            </div>
          </Link>
        </div>
      )}
    </div>
  );
};

export const IncludedCardFee = ({
  componentContent = {},
  handleClickFPTI,
  app
}) => {
  const {
    title,
    fee,
    feeSubText,
    desc,
    linkText,
    link,
    fptiLinkName,
    feeSupText,
    descDisclaimer,
    descImage
  } = componentContent;
  const { context: { location: { domain } = {} } = {} } = app;
  return (
    <div className="details-fees-card">
      <div className="details-fees-card-top">
        <h3>{title}</h3>
        <div className="details-fees-card-fee">
          <sub
            style={{ minHeight: '0px' }}
            className="pay-description font-size-p"
          >
            {feeSupText}
          </sub>
          <h4>{fee}</h4>
          <BodyText
            className="font-size-p"
            dangerouslySetInnerHTML={{ __html: feeSubText }}
          ></BodyText>
        </div>
      </div>
      {desc && (
        <div className="details-fees-card-bottom">
          <div className="details-fees-card-wrapper">
            <BodyText
              className="pay-description font-size-p"
              dangerouslySetInnerHTML={{ __html: desc }}
            ></BodyText>
            {descImage && (
              <img
                style={{
                  width: '186px',
                  marginBottom: '30px',
                  marginTop: '10px'
                }}
                alt=""
                src={descImage}
              />
            )}
            {descDisclaimer && (
              <BodyText
                className="pay-description font-size-p"
                dangerouslySetInnerHTML={{ __html: descDisclaimer }}
              ></BodyText>
            )}
            {link && (
              <Link
                href={link}
                rel={preventTabNabbing(link, domain)}
                onClick={() => handleClickFPTI(fptiLinkName)}
              >
                {linkText}
              </Link>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

feesCard.propTypes = {
  componentContent: PropTypes.object
};

IncludedCardFee.propTypes = {
  componentContent: PropTypes.object,
  cardTitle: PropTypes.string,
  fee: PropTypes.string,
  feeSubtext: PropTypes.string,
  cardFooterText: PropTypes.string,
  fptiLinkName: PropTypes.string,
  handleClickFPTI: PropTypes.func,
  app: PropTypes.object
};

feesSideSection.propTypes = {
  feeSideTitle: PropTypes.string,
  feeSideSubtitle: PropTypes.string,
  feeSideLinkUrl: PropTypes.string,
  feeSideLinkText: PropTypes.string,
  app: PropTypes.object
};

export default {
  feesCard,
  feesSideSection
};
